'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OnScreen = require('lib/OnScreen');

var _OnScreen2 = _interopRequireDefault(_OnScreen);

var _Hero = require('components/Hero/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _Clients = require('components/Clients/Clients');

var _Clients2 = _interopRequireDefault(_Clients);

var _Feature = require('components/Feature/Feature');

var _Feature2 = _interopRequireDefault(_Feature);

var _Media = require('components/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _LogoShape = require('components/LogoShape/LogoShape');

var _LogoShape2 = _interopRequireDefault(_LogoShape);

var _creative = require('./creative.css');

var _creative2 = _interopRequireDefault(_creative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Creative = function (_Component) {
  _inherits(Creative, _Component);

  function Creative() {
    _classCallCheck(this, Creative);

    var _this = _possibleConstructorReturn(this, (Creative.__proto__ || Object.getPrototypeOf(Creative)).call(this));

    _this.state = {
      finishLoading: false,
      cmsData: null,
      features: {},
      hero: {},
      spaces: {},
      results: {},
      clients: {},
      spacesInView: false,
      resultsInView: false
    };
    return _this;
  }

  _createClass(Creative, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.spacesShow = _OnScreen2.default.in(this.refs.spaces, this.showSpaces.bind(this), false);
      this.resultsShow = _OnScreen2.default.in(this.refs.results, this.showResults.bind(this), false);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var fetchCreative = this.props.fetchCreative;


      document.title = 'Creative | Soundscape Agency';
      fetchCreative();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.loading !== newProps.loading) {
        this.setState({
          hero: newProps.hero,
          spaces: newProps.spaces,
          results: newProps.results,
          clients: newProps.clients,
          features: newProps.features,
          finishLoading: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _OnScreen2.default.unsubscribe(this.spacesShow);
      _OnScreen2.default.unsubscribe(this.resultsShow);
    }
  }, {
    key: 'showSpaces',
    value: function showSpaces() {
      this.setState({
        spacesInView: true
      });
    }
  }, {
    key: 'showResults',
    value: function showResults() {
      this.setState({
        resultsInView: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          finishLoading = _state.finishLoading,
          hero = _state.hero,
          spaces = _state.spaces,
          results = _state.results,
          clients = _state.clients,
          features = _state.features;


      return _react2.default.createElement(
        'div',
        { className: _creative2.default.creative },
        _react2.default.createElement(_Hero2.default, {
          title: 'creative.',
          strap: hero.strap,
          bg: hero.bg
        }),
        _react2.default.createElement(
          'section',
          { className: _creative2.default.features },
          _react2.default.createElement(
            'div',
            { className: _creative2.default.featuresInner },
            finishLoading && features.items && features.items.length && features.items.map(function (item, index) {
              var icon = item.icon;
              var title = item.title;
              var copy = item.copy;

              return _react2.default.createElement(_Feature2.default, {
                key: 'featureItem_' + index,
                className: _creative2.default.feature,
                icon: icon,
                title: title,
                copy: copy
              });
            })
          )
        ),
        _react2.default.createElement(
          'section',
          { className: _creative2.default.shape },
          _react2.default.createElement(_LogoShape2.default, { isPiano: true })
        ),
        _react2.default.createElement(
          'section',
          { className: _creative2.default.spaces, ref: 'spaces' },
          _react2.default.createElement(
            'div',
            { className: _creative2.default.spacesInner },
            _react2.default.createElement(
              'div',
              { className: _creative2.default.spacesHero, style: { opacity: this.state.spacesInView ? 1 : 0 } },
              _react2.default.createElement(
                'h3',
                { className: _creative2.default.titleDark },
                spaces.title
              ),
              _react2.default.createElement('p', { className: _creative2.default.strapDark, dangerouslySetInnerHTML: { __html: spaces.strap } })
            ),
            finishLoading && spaces.items && spaces.items.length && _react2.default.createElement(
              _Media2.default,
              {
                ltr: true,
                num: '01',
                title: spaces.items[0].title
                // img={spaces.items[0].image}
                , img: '/images/_temp/bg3.jpg',
                isCirclesBig: true,
                isCanvas: true
              },
              spaces.items[0].copy
            ),
            finishLoading && spaces.items && spaces.items.length && _react2.default.createElement(
              _Media2.default,
              {
                ltr: false,
                num: '02',
                title: spaces.items[1].title
                // img={spaces.items[1].image}
                , img: '/images/_temp/emotional.jpg',
                isCanvas: true,
                isPulse: true
              },
              spaces.items[1].copy
            ),
            finishLoading && spaces.items && spaces.items.length && _react2.default.createElement(
              _Media2.default,
              {
                ltr: true,
                num: '03',
                title: spaces.items[2].title
                // img={spaces.items[2].image}
                , img: '/images/_temp/experimental.jpg',
                isCanvas: true,
                isCircles: true
              },
              spaces.items[2].copy
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { className: _creative2.default.results, ref: 'results' },
          _react2.default.createElement(
            'div',
            { className: _creative2.default.resultsInner, style: { opacity: this.state.resultsInView ? 1 : 0 } },
            _react2.default.createElement(
              'h3',
              { className: _creative2.default.title },
              results.title
            ),
            _react2.default.createElement('p', { className: _creative2.default.strap, dangerouslySetInnerHTML: { __html: results.strap } }),
            _react2.default.createElement(
              'div',
              { className: _creative2.default.resultsListing },
              finishLoading && results.items && results.items.length && _react2.default.createElement(
                'div',
                { className: _creative2.default.result },
                _react2.default.createElement('h3', { className: _creative2.default.resultNum, dangerouslySetInnerHTML: { __html: results.items[0].value } }),
                _react2.default.createElement('h3', { className: _creative2.default.resultTitle, dangerouslySetInnerHTML: { __html: results.items[0].title } }),
                _react2.default.createElement('p', { className: _creative2.default.resultCopy, dangerouslySetInnerHTML: { __html: results.items[0].copy } })
              ),
              finishLoading && results.items && results.items.length && _react2.default.createElement(
                'div',
                { className: _creative2.default.result },
                _react2.default.createElement('h3', { className: _creative2.default.resultNum, dangerouslySetInnerHTML: { __html: results.items[1].value } }),
                _react2.default.createElement('h3', { className: _creative2.default.resultTitle, dangerouslySetInnerHTML: { __html: results.items[1].title } }),
                _react2.default.createElement('p', { className: _creative2.default.resultCopy, dangerouslySetInnerHTML: { __html: results.items[1].copy } })
              ),
              finishLoading && results.items && results.items.length && _react2.default.createElement(
                'div',
                { className: _creative2.default.result },
                _react2.default.createElement('h3', { className: _creative2.default.resultNum, dangerouslySetInnerHTML: { __html: results.items[2].value } }),
                _react2.default.createElement('h3', { className: _creative2.default.resultTitle, dangerouslySetInnerHTML: { __html: results.items[2].title } }),
                _react2.default.createElement('p', { className: _creative2.default.resultCopy, dangerouslySetInnerHTML: { __html: results.items[2].copy } })
              )
            )
          )
        ),
        finishLoading && clients.logos && clients.logos.length && _react2.default.createElement(_Clients2.default, {
          title: clients.title,
          strap: clients.strap,
          clients: clients.logos
        })
      );
    }
  }]);

  return Creative;
}(_react.Component);

exports.default = Creative;


Creative.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Creative/Creative.js
// module id = 321
// module chunks = 1